// 공지사항 유틸리티 함수
import { Gift, Info, TrendingUp } from 'lucide-react';
import type { AnnouncementType, Language } from './types';

// 타입별 아이콘
export function getTypeIcon(type: AnnouncementType): React.ReactNode {
  switch (type) {
    case 'system':
      return <Info className="w-[min(4vw,1rem)] h-[min(4vw,1rem)]" />;
    case 'event':
      return <Gift className="w-[min(4vw,1rem)] h-[min(4vw,1rem)]" />;
    case 'update':
      return <TrendingUp className="w-[min(4vw,1rem)] h-[min(4vw,1rem)]" />;
  }
}

// 타입별 색상 클래스
export function getTypeColor(type: AnnouncementType): string {
  switch (type) {
    case 'system':
      return 'bg-secondary/10 text-secondary border-secondary/20';
    case 'event':
      return 'bg-primary/10 text-primary border-primary/20';
    case 'update':
      return 'bg-warning/10 text-warning border-warning/20';
  }
}

// 상대적 날짜 포맷팅
export function formatAnnouncementDate(date: Date, language: Language): string {
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffHours < 24) {
    return language === 'ko'
      ? `${diffHours}시간 전`
      : language === 'es'
        ? `Hace ${diffHours} h`
        : `${diffHours} h ago`;
  } else if (diffDays < 7) {
    return language === 'ko'
      ? `${diffDays}일 전`
      : language === 'es'
        ? `Hace ${diffDays} días`
        : `${diffDays} days ago`;
  } else {
    return new Intl.DateTimeFormat(
      language === 'ko' ? 'ko-KR' : language === 'es' ? 'es-ES' : 'en-US',
      { year: 'numeric', month: 'short', day: 'numeric' }
    ).format(date);
  }
}
